import React from 'react';
import { Link } from 'react-router-dom';
import { howItWorks } from '../../data/mock';
import { Button } from '../ui/button';
import { ArrowRight, FileText, Search, CheckCircle } from 'lucide-react';

const stepIcons = [FileText, Search, CheckCircle];

const stepImages = [
  {
    src: "https://images.unsplash.com/photo-1762341117875-03dcc0997c96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHx3b21hbiUyMGxhcHRvcCUyMGZpbmFuY2lhbCUyMHBsYW5uaW5nJTIwaG9tZSUyMG9mZmljZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3Njk3MjQ1MzJ8MA&ixlib=rb-4.1.0&q=85&w=600",
    alt: "Online-Anfrage am Laptop"
  },
  {
    src: "https://images.unsplash.com/photo-1565688527174-775059ac429c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBtZWV0aW5nJTIwZmluYW5jaWFsJTIwYWR2aXNvciUyMGRvY3VtZW50cyUyMG9mZmljZSUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3Njk3MjQ1MzV8MA&ixlib=rb-4.1.0&q=85&w=600",
    alt: "Kundengespräch mit Finanzberater"
  },
  {
    src: "https://images.unsplash.com/photo-1758518730384-be3d205838e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGhhbmRzaGFrZSUyMGRlYWwlMjBjbG9zaW5nJTIwYWdyZWVtZW50JTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc2OTcyNDUzOHww&ixlib=rb-4.1.0&q=85&w=600",
    alt: "Handschlag nach Vertragsabschluss"
  }
];

const HowItWorks = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">So funktioniert's</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 mb-4">
            In 3 einfachen Schritten zur Finanzierung
          </h2>
          <p className="text-slate-600">
            Unser Prozess ist transparent und unkompliziert – von der Anfrage bis zur Auszahlung.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-1/4 right-1/4 h-0.5 bg-blue-200 -translate-y-1/2 z-0" />

          <div className="grid md:grid-cols-3 gap-8 relative z-10">
            {howItWorks.map((step, index) => {
              const IconComponent = stepIcons[index];
              const image = stepImages[index];
              return (
                <div key={step.step} className="relative">
                  <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-slate-100 overflow-hidden">
                    {/* Image */}
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={image.src}
                        alt={image.alt}
                        loading="lazy"
                        className="w-full h-full object-cover"
                      />
                      {/* Step Number Badge */}
                      <div className="absolute top-4 left-4 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center shadow-lg">
                        <span className="text-xl font-bold text-white">{step.step}</span>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6 text-center">
                      {/* Icon */}
                      <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mx-auto mb-4">
                        {IconComponent && <IconComponent className="w-6 h-6 text-blue-600" />}
                      </div>

                      <h3 className="text-xl font-semibold text-slate-900 mb-3">
                        {step.title}
                      </h3>
                      <p className="text-slate-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>

                  {/* Arrow for mobile */}
                  {index < 2 && (
                    <div className="flex justify-center my-4 md:hidden">
                      <ArrowRight className="w-6 h-6 text-blue-400 rotate-90" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link to="/anfrage">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl transition-all px-8">
              Jetzt starten
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
